import { render, staticRenderFns } from "./FormPCL.vue?vue&type=template&id=70bcb6f4"
import script from "./FormPCL.vue?vue&type=script&lang=js"
export * from "./FormPCL.vue?vue&type=script&lang=js"
import style0 from "./FormPCL.vue?vue&type=style&index=0&id=70bcb6f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports